import { useRoleLabel } from 'helpers'
import styled from 'styled-components'

import Avatar from 'js/components/Avatar/Avatar'
import Popover from 'js/components/Popover/Popover'
import { useViewerStore } from 'js/lib/stores/ViewerStore'

import ProfileCard from './components/ProfileCard'

export interface Props {
    user: {
        guid: string
        name: string
        icon: string
        vcard: any[]
        roles: string[]
    }
    isOwner: boolean
}

const ProfileCardTrigger = styled.button`
    border-radius: 50%;
    outline-offset: 2px;
`

const UserAvatar = ({ user, isOwner, ...rest }: Props) => {
    const { viewer } = useViewerStore()

    const { name, icon, roles } = user

    const profileCardIsVisible = viewer?.loggedIn
    const badgeRole = useRoleLabel(roles, isOwner)

    const AvatarComponent = (
        <Avatar
            disabled
            role={badgeRole}
            showHoverOverlay={profileCardIsVisible}
            name={name}
            image={icon}
        />
    )

    if (!profileCardIsVisible) {
        return AvatarComponent
    }

    return (
        <div {...rest}>
            <Popover
                trigger="mouseenter focusin"
                touch={['hold', 350]}
                delay
                content={
                    <ProfileCard
                        viewer={viewer}
                        user={user}
                        isOwner={isOwner}
                    />
                }
            >
                <ProfileCardTrigger
                    data-testid="user-avatar-popover-trigger"
                    tabIndex={0}
                    type="button"
                >
                    {AvatarComponent}
                </ProfileCardTrigger>
            </Popover>
        </div>
    )
}

export default UserAvatar
